import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
export default function usePrevious(state) {
  // Based on the react beta docs, we avoid using an effect and a ref here but
  // use another state to store the previous value to compare to.
  // See: https://beta.reactjs.org/reference/react/useState#storing-information-from-previous-renders

  // [previousState currentState]
  var _useState = useState([null, state]),
    _useState2 = _slicedToArray(_useState, 2),
    tuple = _useState2[0],
    setTuple = _useState2[1];
  if (tuple[1] !== state) {
    // Set the new given state value and store the old state as pervious value
    setTuple([tuple[1], state]);
  }
  return tuple[0];
}